import React from 'react'
import PropTypes from 'prop-types'

import TabSpecialization from './Featured/TabSpecialization'
import FeatureSpecialization from './Featured'

const BodySpecilizations = (props) => {
  const {
    featuredSpecializations,
    integrationSettings
  } = props

  return <TabSpecialization
    items={featuredSpecializations.map((especialization = {}, index) => ({
      index: index + 1,
      label: especialization.title,
      meta: especialization.meta,
      content: <FeatureSpecialization
        {...especialization}
        index={index + 1}
        integrationSettings={integrationSettings} />
    }))}
  />
}

BodySpecilizations.propTypes = {
  benefitList: PropTypes.array,
  featuredSpecializations: PropTypes.array,
  faqQuestions: PropTypes.shape({
    title: PropTypes.string,
    list: PropTypes.array
  }),
  integrationSettings: PropTypes.object
}

export default BodySpecilizations
